import React from 'react';
import LightHeader from './LightHeader';
import Footer from '../JobPage/Footer';
import SearchBar from '../JobPage/SearchBar';
import { Container } from '../Components/ui/container';
import { Stack, Inline, Grid } from '../Components/ui/layout';
import { Heading, Text } from '../Components/ui/typography';
import { Card, CardContent, CardHeader, CardTitle } from '../Components/ui/card';
import { Button } from '../Components/ui/button';
import { Badge } from '../Components/ui/badge';
import { Separator } from '../Components/ui/separator';

const LayoffInsights = () => {
  const filterOptions = [
    { label: 'Industry', icon: 'https://cdn.builder.io/api/v1/image/assets/TEMP/9f81a865ef1a9f7b4dd52f3e92a8795862c97492a74e6b5f617068134961bace?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f' },
    { label: 'Region/Location', icon: 'https://cdn.builder.io/api/v1/image/assets/TEMP/9f81a865ef1a9f7b4dd52f3e92a8795862c97492a74e6b5f617068134961bace?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f' },
    { label: 'Layoff Size', icon: 'https://cdn.builder.io/api/v1/image/assets/TEMP/9f81a865ef1a9f7b4dd52f3e92a8795862c97492a74e6b5f617068134961bace?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f' },
  ];

  return (
    <div className="min-h-screen bg-background">
      <LightHeader />
      <main>
        <Container>
          <Stack spacing="2xl" className="py-xl">
            <Heading level="h1" className="text-center text-4xl md:text-5xl mt-20">
              Navigating Workforce Changes: <span className="text-primary">Layoff</span> Insights
            </Heading>
            
            <SearchBar />
            
            <Inline spacing="md" className="flex-wrap justify-center">
              {filterOptions.map((option, index) => (
                <Button 
                  key={index} 
                  variant="outline" 
                  className="gap-2"
                >
                  <img src={option.icon} alt="" className="w-5 h-5" />
                  {option.label}
                </Button>
              ))}
            </Inline>

            <Stack spacing="md">
              <Heading level="h2" className="text-2xl md:text-3xl">
                Statistics Section
              </Heading>
              <Text size="lg" variant="muted">
                Key Trends in Layoffs
              </Text>
            </Stack>

            <Grid cols={2} gap="xl" className="grid-cols-1 md:grid-cols-2">
              <Card>
                <CardHeader>
                  <CardTitle>Company Name</CardTitle>
                </CardHeader>
                <CardContent>
                  <Stack spacing="sm">
                    <Text variant="muted">Industry</Text>
                    <Text variant="muted">Number of Employees Laid Off</Text>
                    <Text variant="muted">Date</Text>
                    <Button variant="default" className="mt-4">
                      View Details
                    </Button>
                  </Stack>
                </CardContent>
              </Card>
              
              <Card>
                <CardContent className="p-0">
                  <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/d622946e1e52f00c91c0d971edd8ba6a84b886b81bfcbe20b58697b721ec9b2d?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f"
                    alt="Layoff chart"
                    className="w-full h-auto rounded-lg"
                  />
                </CardContent>
              </Card>
            </Grid>

            <Separator />

            <Stack spacing="md">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/5ecf7dcd7f86a6207644d3296e150c2595aed089d77170c91287100eb3554b60?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f"
                alt=""
                className="w-full h-auto rounded-lg"
              />
              <Text size="lg" className="text-justify">
                Lorem ipsum dolor sit amet consectetur. Sed platea elementum in morbi quam sed. Odio at nulla dolor purus aliquam nec turpis a.
                Fringilla tellus egestas vitae vestibulum mollis commodo. Viverra mattis amet urna lacus quis ultrices duis et sit.
              </Text>
            </Stack>

            <Grid cols={2} gap="xl" className="grid-cols-1 md:grid-cols-2">
              <Card>
                <CardContent className="p-lg">
                  <Inline spacing="lg" align="start" className="flex-col md:flex-row">
                    <img
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/07f5cd5102667a0c00e17c854a068ddf61c06ec9717075d39fe609a11c3c8aa1?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f"
                      alt=""
                      className="w-24 h-24 md:w-32 md:h-32 object-contain"
                    />
                    <Stack spacing="sm" className="flex-1">
                      <Heading level="h3" className="text-xl">
                        Looking for a job?
                      </Heading>
                      <Text variant="muted">
                        Lorem ipsum dolor sit amet consectetur. Sed platea elementum in morbi quam sed.
                      </Text>
                      <Button variant="default" className="gap-2 w-full md:w-auto">
                        Start Searching
                        <img
                          src="https://cdn.builder.io/api/v1/image/assets/TEMP/c4dacfef926e827716ff4bfc706c3befb4bc3dd9ffa21bd22978897511dcce6d?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f"
                          alt=""
                          className="w-5 h-5"
                        />
                      </Button>
                    </Stack>
                  </Inline>
                </CardContent>
              </Card>
              
              <Card>
                <CardContent className="p-lg">
                  <Inline spacing="lg" align="start" className="flex-col md:flex-row">
                    <img
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/c2cd65406df8ced25e4d2fdb3e46b684051c057a1dd5e562c3c3e184d6e42f1b?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f"
                      alt=""
                      className="w-24 h-24 md:w-32 md:h-32 object-contain"
                    />
                    <Stack spacing="sm" className="flex-1">
                      <Heading level="h3" className="text-xl">
                        Looking for Hiring?
                      </Heading>
                      <Text variant="muted">
                        Lorem ipsum dolor sit amet consectetur. Sed platea elementum in morbi quam sed.
                      </Text>
                      <Button variant="default" className="gap-2 w-full md:w-auto">
                        Start Hiring
                        <img
                          src="https://cdn.builder.io/api/v1/image/assets/TEMP/3c95dbb08849a1613c0b46a2f8aafbc8379e326401473eefa5c3d164183d5d55?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f"
                          alt=""
                          className="w-5 h-5"
                        />
                      </Button>
                    </Stack>
                  </Inline>
                </CardContent>
              </Card>
            </Grid>
          </Stack>
        </Container>
      </main>
      <Footer />
    </div>
  );
};

export default LayoffInsights;
